import React, {
  SyntheticEvent,
  useEffect,
  useRef,
  useState,
} from "react";
import images from "../../assets/images";
import "./TermsAndPrivacyPolicy.scss";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { Tab, Tabs } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { visibility } from "../../redux/slices/rightSideAd";
import axios, { AxiosResponse } from "axios";
import Loader from "../../components/Loader/Loader";
import { SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from "../../utils/constants";
import { getScreenDimensions } from "../../utils/helper";

export const CustomTab = styled(Tab)(({ theme }) => ({
  fontFamily: "var(--font-inter)",
  fontWeight: 500,
  fontSize: 12,
  lineHeight: "14.52px",
  textTransform: "capitalize",
  padding: "12px",
  flex: 1,
  maxWidth: "168px", // Need to remove while using all tabs
  display: "flex",
  minHeight: "32px",
  // maxWidth: '140px',
  columnGap: "10px",
  borderRadius: "20px",
  justifyContent: "center",
  alignItems: "center",
  "&.Mui-selected": {
    color: "white",
    backgroundColor: "#008CD1",
  },
  "&:not(.Mui-selected)": {
    color: "#121C5E",
    backgroundColor: "#F0F3F5",
    border: "1px solid #121C5E",
  },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  "& .MuiTabs-indicator": { display: "none" },
}));

const TermsAndPrivacyPolicy = () => {
  const navigate = useNavigate();
  const { backArrow } = images;
  const dispatch = useAppDispatch();
  dispatch(visibility({ isVisible: false }));
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const katon_cms = process.env.REACT_APP_KATON_CMS_SITE;
  const [content, setContent] = useState();
  const [data, setData] = useState("");
  const role = useAppSelector((state) => state.auth.role);
  const {isMobileScreen} = getScreenDimensions();

  const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response: AxiosResponse = await axios.get(
          `${katon_cms}/classroom_legals`,
          {
            headers: {
              "X-Hash-Key": process.env.REACT_APP_KATON_SITE_API_KEY,
            },
          }
        );
        const content = response.data;
        setContent(content);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Stop the loader
      }
    };

    fetchData();
  }, []);

  const contentDivRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (content) {
      switch (activeTab) {
        case 0:
          setData(content[0]["Privacy Policy"]);
          break;
        case 1:
          setData(content[0]["Terms of Use"]);
          break;
        case 2:
          setData(content[0]["Cancellation Policy"]);
          break;
      }
      if (contentDivRef.current) {
        contentDivRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }, [activeTab, content]);

  return (
    <div className="TermsAndPrivacyPolicyCtn" style={{
      paddingLeft: (role === TEACHER_ROLE ||role === STUDENT_ROLE ) && !isMobileScreen  ? '70px' : undefined
     }}>
      <div className="TermsAndPrivacyPolicyHeader">
        <img
          src={backArrow}
          alt="backButton"
          className="TermsAndPrivacyPolicyBackBtn"
          onClick={() => navigate(role === SCHOOL_ADMIN ? "/admin-help" : role === TEACHER_ROLE ? "/teacher-help" : role === STUDENT_ROLE ? "/student-help" : "")}
          style={{
            position: "relative",
            right: "45px",
          }}
        />
        <h1 className="TermsAndPrivacyPolicyHeading"  style={{
            position: "relative",
            right: "50px",
          }}>Legal</h1>
      </div>
      {(loading || data === "") ? (
        <Loader />
      ) : (
        <>
          <div className="StyledTabsContainer">
            <StyledTabs value={activeTab} onChange={handleChangeTab}>
              <CustomTab label={"Privacy Policy"} className="insidePrivacyPolicyTab"/>
              <CustomTab label={"Terms of Use"} className="insideTermsOfUseTab"/>
              <CustomTab label={"Cancellation Policy"} className="insideCancellationPolicyTab"/>
            </StyledTabs>
          </div>

          <div
            className="privacy-policy-content"
            dangerouslySetInnerHTML={{ __html: data }}
            ref={contentDivRef}
          ></div>
        </>
      )}
    </div>
  );
};

export default TermsAndPrivacyPolicy;
